$(function () {
    var btn = $('.qmr-back-to-top');

    $(window).scroll(function () {
        if ($(window).scrollTop() > 300) {
            btn.removeClass('hidden');
        } else {
            btn.addClass('hidden');
        }
    });

    btn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, '0');
    });
    if(!$('body').hasClass('t-index')){
    var height_header = $('header#header').height();
    $('main').css('paddingTop', height_header+17);
    }
    $('.qmr-filter-input input').change(function(){
        $(this).closest('form').submit();
    });
    $('.close-submenu').click(function(){
        $(this).parents('details').removeAttr('open');
    });
    $('.qmr_notifier-close').click(function(){
        $('.noticer').slideUp();
    })
})